export default __webpack_public_path__ + "static/media/button_point-off.b47436b2.svg";